module.exports = new Promise(function(resolve) {
  function getAppConfig (apps) {
    var appConfig = apps['kiosk'];
    try {
      var predefinedVersion = JSON.parse(localStorage.getItem('vm/__appVersion'));
      if (predefinedVersion) {
        appConfig.version = predefinedVersion;
      }
    } catch (e) {
      console.log(e);
    }
    return appConfig;
  }
  function loadApp(appConfig) {
    var remoteUrl = window.location.origin + '/apps/kiosk_' + appConfig.version + '/kiosk.js';
    var script = document.createElement('script');
    script.src = remoteUrl;
    script.onload = function() {
      var proxy = {
        get: function(request) { return window['kiosk'].get(request); },
        init: function(arg) {
          try {
            return window['kiosk'].init(arg);
          } catch(e) {
            console.log('remote container already initialized');
          }
        }
      }
      resolve(proxy);
    }
    document.head.appendChild(script);
  }
  function fetchJSON(path) {
    return new Promise(function(res) {
      var request = new XMLHttpRequest();
      request.addEventListener('load', function() {
        res(JSON.parse(this.responseText));
      });
      request.open('GET', path);
      request.send();
    });
  }
  window.__vmosAppsRequest__ = window.__vmosAppsRequest__ || fetchJSON(window.location.origin + '/apps.json');
  window.__vmosConfigRequest__ = window.__vmosConfigRequest__ || fetchJSON(window.location.origin + '/config.json');
  window.__vmosAppsRequest__.then(getAppConfig).then(loadApp);
  window.__vmosConfigRequest__.then(function(config) {
    window.__vmosConfig__ = config;
  });
})
;